import { useEffect, useMemo } from 'react';

import { datadogRum } from '@datadog/browser-rum';
import { APP_NAME } from 'constants/Global.constants';

import useProject from 'hooks/useProject';

interface HelmetProps {
  title?: string;
}

const useSiteTitle = (title?: string) => {
  const { project } = useProject();

  return useMemo(
    () =>
      [APP_NAME, project?.name ?? '', title]
        .filter(x => x)
        .slice(-3)
        .join(' - '),
    [project?.name, title],
  );
};

const Helmet = ({ title }: HelmetProps) => {
  const siteTitle = useSiteTitle(title);

  useEffect(() => {
    document.title = siteTitle;
  }, [siteTitle]);

  useEffect(() => {
    if (title) {
      datadogRum.startView(title);
    }
  }, [title]);

  return null;
};

export default Helmet;
